import React from 'react'

import { Root, Inner, Title, Text } from './styles'

const WarningBanner = () => (
  <Root role='alert'>
    <Inner>
      <Title>Наши пользователи и покупатели,</Title>
      <Text>
        Из-за крупного сбоя в экосистеме Яндекса приостановилась работа не
        только их собственных ресурсов, но и многих сторонних сайтов и
        приложений, в том числе и наших внутренних сервисов.
      </Text>
      <Text>
        Мы активно занимаемся восстановлением наших систем и делаем всё от нас
        зависящее, чтобы вернуться к привычному режиму работы по мере устранения
        последствий сбоя Яндекса.
      </Text>
      <Text>Будем держать вас в курсе новостей!</Text>
    </Inner>
  </Root>
)

export default WarningBanner
